'use client';

import PhotoGallery from '../PhotoGallery';
import MuiBox from '@new-components/atoms/MuiBox';
import {useToggle} from '@hooks/useToogle';
import {ImgProps} from '@custom-types/ImgProps';

export type CommunityGalleryProps = {
  images: ImgProps[];
  children: React.ReactNode;
};

const CommunityGallery = (props: CommunityGalleryProps) => {
  const [open, setOpen] = useToggle(false);
  return (
    <MuiBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        pb:{md:'32px'},
      }}>
      <MuiBox
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: '12vw auto 1fr',
            md: '8vw auto 1fr',
          },
        }}
        onClick={() => setOpen(true)}>
        {props.children}
      </MuiBox>
      <PhotoGallery
        open={open}
        onClose={() => setOpen(false)}
        images={props.images}
      />
    </MuiBox>
  );
};

export default CommunityGallery;
